"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageDirectionServer = void 0;
var MessageDirectionServer;
(function (MessageDirectionServer) {
    MessageDirectionServer["CustomerToBusiness"] = "CUSTOMER_TO_BUSINESS";
    MessageDirectionServer["BusinessToCustomer"] = "BUSINESS_TO_CUSTOMER";
})(MessageDirectionServer = exports.MessageDirectionServer || (exports.MessageDirectionServer = {}));
//# sourceMappingURL=public-types.js.map